export const homeConstants = {
    ...getConstantObj()
};

function getConstantObj() {
    let obj = {
        getOneClickActionDetails_request: "getOneClickActionDetails_request",
        getOneClickActionDetails_success: "getOneClickActionDetails_success",
        getOneClickActionDetails_failure: "getOneClickActionDetails_failure",
    
        getCompanyDetails_request: "getCompanyDetails_request",
        getCompanyDetails_success: "getCompanyDetails_success",
        getCompanyDetails_failure: "getCompanyDetails_failure",        
    }

    let obj_formatted = {};
    let domain = "distributorPortal.home/";
    for (let property in obj) {
        if (obj.hasOwnProperty(property)) {
            obj_formatted[property] = domain + obj[property];
        }
    }

    return obj_formatted;
}